import { render, staticRenderFns } from "./PartnerChange.vue?vue&type=template&id=8387744c"
import script from "./PartnerChange.vue?vue&type=script&lang=js"
export * from "./PartnerChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports